import { SearchableVendorTaxonomyKey } from '@zola-helpers/client/dist/es/marketplace/vendorTaxonomyKeys';
import { StorefrontCardView } from '@zola/svc-marketplace-ts-types';

import { doTrackStorefrontListViewed } from '~/contexts/TrackingContracts/trackingContractsHelpers';

import {
  buildSearchFilterTracking,
  buildSearchSortTracking,
} from '../../../util/buildSearchFilterTracking';
import { VendorSearchRequest, VendorSearchRequestType } from '../types/types';

const SEARCH_PATH_REGEX = /\/wedding-vendors\/(search|near-me)\//;

/**
 * Determines if the page should redirect to the canonical URL
 *
 * @returns True if the search slug does not match the canonical search slug; false otherwise
 */
export const shouldRedirect = (url: string, canonicalUrl: string) => {
  if (!url || !canonicalUrl) {
    return false;
  }
  const searchSlug = url.replace(SEARCH_PATH_REGEX, '').split('?')[0];
  const canonicalSearchSlug = canonicalUrl.replace(SEARCH_PATH_REGEX, '').split('?')[0];
  return searchSlug !== canonicalSearchSlug;
};

/**
 * Track product list views on page load and follow-up searches
 */
export const trackVendorSearch = (
  vendorSearch: VendorSearchRequest,
  searchRequest: VendorSearchRequestType,
  storefrontList: StorefrontCardView[]
) => {
  const taxonomyKey = vendorSearch.selectedTaxonomy?.key as SearchableVendorTaxonomyKey | undefined;

  const trackingFilters = buildSearchFilterTracking(
    searchRequest,
    vendorSearch.selectedLocation,
    vendorSearch.selectedFacets
  );

  const trackingSort = buildSearchSortTracking(
    vendorSearch.sorting,
    taxonomyKey,
    vendorSearch.selectedLocation
  );

  doTrackStorefrontListViewed({
    storefrontList,
    filters: trackingFilters,
    taxonomyKey,
    sorts: trackingSort ? [trackingSort] : [],
    listingShelfName: 'SEARCH_RESULTS_PAGE',
    includeTags: true,
  });
};
